module.exports = __webpack_public_path__ + "static/media/naked-news-in-red.cca7a954.png";